import FileDownloader from './FileDownloader';

export default FileDownloader;
